import React, { useState } from 'react';

const MultiplyByFive = () => {
  const [currentNumber, setCurrentNumber] = useState(2);
  const [step1, setStep1] = useState('');
  const [step2, setStep2] = useState('');
  const [final, setFinal] = useState('');
  const [feedback, setFeedback] = useState({ message: '', color: '' });

  const checkAnswer = () => {
    const correctStep1 = 10 * currentNumber;
    const correctStep2 = correctStep1 / 2;
    const correctFinal = correctStep2;

    if (
      Number(step1) === correctStep1 &&
      Number(step2) === correctStep2 &&
      Number(final) === correctFinal
    ) {
      setFeedback({ message: '✅ Correct! Great job!', color: 'green' });
    } else {
      setFeedback({ message: '❌ Try again!', color: 'red' });
    }
  };

  const generateQuestion = () => {
    setCurrentNumber(Math.floor(Math.random() * 10) + 1);
    setStep1('');
    setStep2('');
    setFinal('');
    setFeedback({ message: '', color: '' });
  };

  return (
    <div
      style={{
        fontFamily: 'Segoe UI, sans-serif',
        backgroundColor: '#fef9c3',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
        minHeight: '100vh',
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '1.5rem',
          borderRadius: '12px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          width: '100%',
          maxWidth: '360px',
        }}
      >
        <h3 style={{ color: '#eab308', marginBottom: '1rem' }}>Half of Ten!</h3>
        <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
          {`What is 5 × ${currentNumber}?`}
        </p>

        {/* Step 1 */}
        <p
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '0.8rem',
          }}
        >
          <span style={{ marginRight: '6px' }}>Step 1: 10 × ? =</span>
          <input
            type="number"
            value={step1}
            onChange={(e) => setStep1(e.target.value)}
            style={{
              padding: '0.4rem',
              width: '70px',
              textAlign: 'center',
            }}
          />
        </p>

        {/* Step 2 */}
        <p
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '0.8rem',
          }}
        >
          <span style={{ marginRight: '6px' }}>Step 2: Half =</span>
          <input
            type="number"
            value={step2}
            onChange={(e) => setStep2(e.target.value)}
            style={{
              padding: '0.4rem',
              width: '70px',
              textAlign: 'center',
            }}
          />
        </p>

        {/* Final Answer */}
        <p
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '1rem',
          }}
        >
          <span style={{ marginRight: '6px' }}>Final Answer =</span>
          <input
            type="number"
            value={final}
            onChange={(e) => setFinal(e.target.value)}
            style={{
              padding: '0.4rem',
              width: '70px',
              textAlign: 'center',
            }}
          />
        </p>

        {/* Buttons - side by side */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1rem',
            marginTop: '1rem',
          }}
        >
          <button
            onClick={checkAnswer}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#34d399',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            Check
          </button>

          <button
            onClick={generateQuestion}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            Next
          </button>
        </div>

        {/* Feedback message */}
        <div
          style={{
            marginTop: '1rem',
            fontWeight: 'bold',
            color: feedback.color,
          }}
        >
          {feedback.message}
        </div>
      </div>
    </div>
  );
};

export default MultiplyByFive;